import(/* webpackMode: "eager" */ "/codebuild/output/src35513360/src/student-management-ui/app/auth/credentials-signin/page.tsx");
